import { validateTidalLicense } from "../../base/index.js";
import { removeNonWord } from "./removeNonWord.js";
import { replaceAccents } from "./replaceAccents.js";
import { trim } from "./trim.js";
function slugify(source, delimiter = "-") {
  return trim(removeNonWord(replaceAccents(source))).replace(/ +/g, delimiter).toLowerCase();
}
validateTidalLicense();
export {
  slugify
};
//# sourceMappingURL=slugify.js.map
